import { AdminFeedbackViewModel } from '@common/model/admin/catalog/feedback/view';
import { Button } from '@cp/ds/src/components/button';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { coreModerationApi } from 'src/entities/moderation';
import { ModerationStatus } from '@common/model/moderation/moderationStatus';
import { useFeedbackEdit } from 'src/features/feedback';
import { AsyncResult } from '@youhelp-ru/core';
import { resultFromRTK } from '@cp/shared/form';
import { useToast } from '@cp/shared/toast';
import { SerializedError } from '@reduxjs/toolkit';
import { ApiServerError } from '@cp/utils/rtk/query/model';
import { useProcessingAndReviews } from '../processingAndReviews';
import { useGetItems } from '../../model/useGetItems';

export const ReviewFooter = ({ feedback }: { feedback: AdminFeedbackViewModel }) => {
  const toast = useToast();
  const { data, form } = useProcessingAndReviews();
  const [editCase, isEditLoading] = useFeedbackEdit();
  const moderationStatus = form.watch('moderationStatus');
  const [approve, { isLoading: isApproveLoading }] = coreModerationApi.endpoints.moderationApprove.useMutation();
  const [decline, { isLoading: isDeclineLoading }] = coreModerationApi.endpoints.moderationDecline.useMutation();
  const { refetch: refetchSuccessCount } = useGetItems({ ...form.getValues(), moderationStatus: ModerationStatus.Success }, true);
  const { refetch: refetchDeclineCount } = useGetItems({ ...form.getValues(), moderationStatus: ModerationStatus.NotPass }, true);

  const handleResult = (cb: () => AsyncResult<unknown, SerializedError | ApiServerError>) => () =>
    cb().then((result) =>
      result
        .tap(() => {
          refetchSuccessCount();
          refetchDeclineCount();
          data.refetch();
        })
        .tapError((err) => toast('error', err.message)),
    );

  const handleEdit = handleResult(() => editCase(feedback));
  const handleApprove = handleResult(() =>
    resultFromRTK(approve({ id: feedback.review!.moderationId! })).then((r) => r.tap(() => toast('success', 'Отзыв одобрен'))),
  );
  const handleDecline = handleResult(() =>
    resultFromRTK(decline({ id: feedback.review!.moderationId! })).then((r) => r.tap(() => toast('success', 'Отзыв отклонен'))),
  );

  if (!feedback.review?.moderationId) {
    return null;
  }

  const isLoading = isApproveLoading || isDeclineLoading || isEditLoading;

  return (
    <Stack spacing={1}>
      {feedback.review && <Typography>{feedback.review.text}</Typography>}
      <Stack flexDirection="row" gap={1}>
        {moderationStatus !== ModerationStatus.Success && (
          <Button disabled={isLoading} loading={isApproveLoading} onClick={handleApprove} size="extraSmall">
            Опубликовать
          </Button>
        )}
        {moderationStatus !== ModerationStatus.NotPass && (
          <Button
            color="pink"
            disabled={isLoading}
            loading={isDeclineLoading}
            onClick={handleDecline}
            size="extraSmall"
            variant="secondary"
          >
            Отклонить
          </Button>
        )}
        <Button color="gray ultra light" onClick={handleEdit} size="extraSmall" variant="secondary">
          Редактировать
        </Button>
      </Stack>
    </Stack>
  );
};
